import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import format from '../../helpers/format'
import {
  LinkIcon
} from '../../components'
import Styles from './PlanScorecardFundDetails.css'


@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardFundDetails extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)
    this.state = {
      fund: props.fund,
      showFundDetails: false,
    }
  }

  render() {
    const { fund, showFundDetails } = this.state

    //
    return(
      <div styleName='fund-details-table-switch-wrap'>
        <button
          styleName='fund-details-table-switch'
          onClick={
            () => {
              this.setState(
                { showFundDetails: !showFundDetails }
              )
            }
          }
        >
          Fund details <LinkIcon
            faclass={
              showFundDetails ?
                'fa-angle-up' :
                'fa-angle-down'
            }
          />
        </button>
        <SlideDown>
          {
            showFundDetails ?
              (
                <div>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Plan option
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>{fund.label}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Rated as
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>
                        {fund.fund_legal_name} {fund.ticker ? (<span>[{fund.ticker}]</span>) : null}
                      </b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Fund manager
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>
                        { fund.fund_family_name || fund.fund_family_label }
                      </b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Fund group
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val'>
                      <b>{fund.category_group}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Percent rated
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val r'>
                      <b>{format.perc(fund.percent_rated)}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Percent rated, long assets
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val r'>
                      <b>{format.perc(fund.percent_rated_long)}</b>
                    </Col>
                  </Row>
                  <Row styleName='dtls-tbl-row'>
                    <Col xs={6} styleName='dtls-tbl-lbl'>
                      Portfolio data as of
                    </Col>
                    <Col xs={6} styleName='dtls-tbl-val r'>
                      <b>{fund.portfolio_date}</b>
                    </Col>
                  </Row>
                </div>
              ) :
              null
          }
        </SlideDown>
      </div>
    )
  }
}

